export const PIT_PORT_OWNER_ENTITY_TYPE = {
  INDIVIDUAL_PS: "individual_ps",
  CORPORATION_PS: "corporation_ps",
  CORPORATION_OEM: "corporation_oem",
} as const;

export const PIT_PORT_OWNER_ENTITY_TYPE_LABEL = {
  [PIT_PORT_OWNER_ENTITY_TYPE.INDIVIDUAL_PS]: "個人",
  [PIT_PORT_OWNER_ENTITY_TYPE.CORPORATION_PS]: "法人",
  [PIT_PORT_OWNER_ENTITY_TYPE.CORPORATION_OEM]: "OEM",
} as const;
